import { ApiRequestInterceptor } from "./apiRequest";
import { CONTACT } from "../Constants/Endpoints";

export const fetchContact = async (body) => {
  const { code, data } = await ApiRequestInterceptor(CONTACT.sendmail, "POST", body);
  return {
    statusCode: code,
    message: data?.message,
    data,
  };
};
